import script from "./WorkflowFlowBuilderPage.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowFlowBuilderPage.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowFlowBuilderPage.vue?vue&type=style&index=0&id=0c7b08cc&lang=css"
import "./WorkflowFlowBuilderPage.vue?vue&type=style&index=1&id=0c7b08cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c7b08cc"]])

export default __exports__